<template>
  <div>
    <div v-if="!isAdding">
      <div class="row q-mb-sm items-center">
        <div class="col-9">
          <div class="row items-center q-col-gutter-x-md">
            <div class="title q-my-none q-mx-none">Featured Listing</div>

            <div>
              <q-btn color="primary" @click="addFeaturedListing">
                <q-icon name="mdi-plus-circle"> </q-icon>
                <span
                  class="sustainability-font q-mx-sm"
                  style="font-size: 13px"
                >
                  Add
                </span>
              </q-btn>
            </div>
          </div>
        </div>
        <div class="col-3">
          <q-input
            class="searchbar float-right"
            style="max-width: 70%"
            filled
            v-model="searchText"
            debounce="200"
            label="Search"
            clearable
            dense
          >
            <template #prepend>
              <q-icon name="mdi-magnify"></q-icon>
            </template>
          </q-input>
        </div>
      </div>
      <div class="row q-mt-lg">
        <div class="col-12">
          <data-table
            style="height: calc(100vh - 280px)"
            flat
            :filter="searchText"
            :data="data"
            :columns="columns"
            headerBgColor="#162c47"
            headerTextColor="white"
            @rowDoubleClick="onDoubleClick"
          >
            <template slot="body-cell-image" slot-scope="data">
              <q-td :props="data.props">
                <q-icon
                  size="sm"
                  v-if="data.props.row.imageUrl"
                  name="mdi-check-circle"
                  color="green"
                >
                </q-icon>
              </q-td>
            </template>
            <template slot="body-cell-actions" slot-scope="data">
              <q-td :props="data.props">
                <q-btn
                  round
                  color="red"
                  flat
                  icon="mdi-delete"
                  @click="removeFeaturedListing(data.props.row)"
                  size="md"
                  class="float-right"
                >
                  <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                    Remove Find Entry
                  </q-tooltip>
                </q-btn>
              </q-td>
            </template>
          </data-table>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row q-mb-sm items-center">
        <div class="col-9">
          <div class="row items-center q-col-gutter-x-md">
            <div>
              <q-btn flat @click="backFromForm">
                <q-icon name="mdi-arrow-left"> </q-icon>
              </q-btn>
            </div>
            <div class="title q-my-none q-mx-none">Featured Listing</div>
          </div>
        </div>
      </div>
      <div>
        <featured-listing-form
          @closeForm="backFromForm"
        ></featured-listing-form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DataTable from "@/components/datatable/datatable.vue";
import featuredListingForm from "@/components/solutions/featuredListingTab/featuredListingForm/featuredListingForm.vue";
export default {
  components: {
    DataTable,
    featuredListingForm,
  },
  watch: {
    $route: {
      handler() {
        this.handleRoute();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      data: "solutions/findEntries/featuredListings/list",
    }),

    columns() {
      return [
        {
          name: "id",
          label: "ID",
          align: "left",
          field: "id",
          style:
            "min-width: 80px;max-width: 80px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "image",
          label: "Image",
          align: "left",
          field: "imageUrl",
          style:
            "min-width: 80px;max-width: 80px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "productService",
          label: "Product / Service",
          align: "left",
          field: "productService",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          sortable: true,
        },
        {
          name: "supplierName",
          label: "Supplier Name",
          align: "left",
          field: "supplierName",
          sortable: true,
        },
        {
          name: "serviceArea",
          label: "Service Area",
          align: "left",
          field: "serviceArea",
          sortable: true,
        },
        {
          name: "createdAt",
          label: "Created At",
          align: "left",
          field: "created_at",
          format: (val) => this.$options.filters.gridDateFormat(val),
          sortable: true,
        },

        {
          name: "actions",
          label: "Actions",
          align: "right",
          field: "delete",
          style:
            "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
        },
      ];
    },
  },

  data: () => ({
    isAdding: false,
    searchText: "",
  }),
  mounted() {
    this.$store.dispatch(
      "solutions/findEntries/featuredListings/loadAllBySolutionsID",
      this.$route.params.id
    );
    this.handleRoute();
  },
  methods: {
    async addFeaturedListing() {
      let result = await this.$store.dispatch(
        "solutions/findEntries/featuredListings/new",
        {
          status: "temp",
        }
      );
      if (result.Result == "Success") {
        this.$router.push(
          this.$route.path + "/featuredListing/" + result.Response.newId
        );
      }
    },
    handleRoute() {
      if (this.$route.params.hasOwnProperty("featuredFindEntry_id")) {
        this.isAdding = true;
      }
    },
    onDoubleClick(row) {
      this.$router.push(this.$route.path + "/featuredListing/" + row.id);
    },
    removeFeaturedListing(row) {
      this.$swal({
        title: "Warning",
        text: "You are about to delete this Item. This is irreversible",
        type: "warning",
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
        showCancelButton: true,
        confirmButtonColor: "#f58122",
      }).then(async (res) => {
        if (res.value) {
          let payload = { ...row };
          payload["deleted_at"] = 1;

          let result = await this.$store
            .dispatch("solutions/findEntries/featuredListings/save", payload)
            .then((result) => {
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "Featured Listing has been removed.",
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        }
      });
    },
    backFromForm() {
      this.$router.push("/solutions/" + this.$route.params.id);
      this.isAdding = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 13px;
}
</style>
